import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Geolocation, Profile } from "@brg/api";
import urlApi from 'shared/actions/urlApi';

export interface ProfileSliceInterface {
    isFetchingUserLocation: boolean
    profile: Profile | undefined
    userLocation: Geolocation | null
    userLocationByAccountId: Geolocation | null
}

export const initialState: ProfileSliceInterface = {
    isFetchingUserLocation: false,
    profile: undefined,
    userLocation: null,
    userLocationByAccountId: null,
}


export const getUserLocation = createAsyncThunk<any, void>(
    'userCurrencies/getUserLocation',
    async (undefined, thuncApi) => {
        try {
            let geoLocation = await urlApi().getGeoLocation()
            return geoLocation
        } catch (err: any) {
            return thuncApi.rejectWithValue(err?.message)
        }
    }
)

export const getUserLocationByAccountId = createAsyncThunk<any, void>(
    'profile/getUserLocation',
    async (undefined, thuncApi) => {
        try {
            const accountId = 'd0a87bd32c454b65b987a5cf37d8aac2';
            return await urlApi().getGeoLocationByAccountId({ accountId })
        } catch (err: any) {
            return thuncApi.rejectWithValue(err?.message)
        }
    }
)

export const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: { },
    extraReducers: {
        [getUserLocation.pending.toString()]: (state) => {
            state.isFetchingUserLocation = true
            state.userLocation = null
        },
        [getUserLocation.fulfilled.toString()]: (state, action) => {
            state.isFetchingUserLocation = false;
            state.userLocation = action.payload;
        },
        [getUserLocationByAccountId.pending.toString()]: (state) => {
            state.userLocationByAccountId = null
        },
        [getUserLocationByAccountId.fulfilled.toString()]: (state, action) => {
            state.userLocationByAccountId = action.payload;
        },
        [getUserLocationByAccountId.rejected.toString()]: (state) => {
            state.userLocationByAccountId = null;
        },
    },
})

export default profileSlice

export const ProfileSelector = (state: any): ProfileSliceInterface => state.profile
export const UserLocationSelector = (state: any): any => ({
    userLocation: state.profile.userLocation,
    isFetchingUserLocation: state.profile.isFetchingUserLocation,
})
export const UserLocationByAccountIdSelector = (state: any) => state.profile.userLocationByAccountId;
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Geolocation, Profile } from "@brg/api";
import urlApi from 'shared/actions/urlApi';

export interface ProfileSliceInterface {
    isFetchingUserLocation: boolean
    profile: Profile | undefined
    userLocation: Geolocation | null
    userLocationByAccountId: Geolocation | null
}

export const initialState: ProfileSliceInterface = {
    isFetchingUserLocation: false,
    profile: undefined,
    userLocation: null,
    userLocationByAccountId: null,
}


export const getUserLocation = createAsyncThunk<any, void>(
    'userCurrencies/getUserLocation',
    async (undefined, thuncApi) => {
        try {
            let geoLocation = await urlApi().getGeoLocation()
            return geoLocation
        } catch (err: any) {
            return thuncApi.rejectWithValue(err?.message)
        }
    }
)

export const getUserLocationByAccountId = createAsyncThunk<any, void>(
    'profile/getUserLocation',
    async (undefined, thuncApi) => {
        try {
            const accountId = 'd0a87bd32c454b65b987a5cf37d8aac2';
            return await urlApi().getGeoLocationByAccountId({ accountId })
        } catch (err: any) {
            return thuncApi.rejectWithValue(err?.message)
        }
    }
)

export const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: { },
    extraReducers: {
        [getUserLocation.pending.toString()]: (state) => {
            state.isFetchingUserLocation = true
            state.userLocation = null
        },
        [getUserLocation.fulfilled.toString()]: (state, action) => {
            state.isFetchingUserLocation = false;
            state.userLocation = action.payload;
        },
        [getUserLocationByAccountId.pending.toString()]: (state) => {
            state.userLocationByAccountId = null
        },
        [getUserLocationByAccountId.fulfilled.toString()]: (state, action) => {
            state.userLocationByAccountId = action.payload;
        },
        [getUserLocationByAccountId.rejected.toString()]: (state) => {
            state.userLocationByAccountId = null;
        },
    },
})

export default profileSlice

export const ProfileSelector = (state: any): ProfileSliceInterface => state.profile
export const UserLocationSelector = (state: any): any => ({
    userLocation: state.profile.userLocation,
    isFetchingUserLocation: state.profile.isFetchingUserLocation,
})
export const UserLocationByAccountIdSelector = (state: any) => state.profile.userLocationByAccountId;
